import { render, staticRenderFns } from "./pkqUserStatistics.vue?vue&type=template&id=4a6c8d84&scoped=true"
import script from "./pkqUserStatistics.vue?vue&type=script&lang=js"
export * from "./pkqUserStatistics.vue?vue&type=script&lang=js"
import style0 from "./pkqUserStatistics.vue?vue&type=style&index=0&id=4a6c8d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6c8d84",
  null
  
)

export default component.exports